import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import { Grid, Tab, Tabs, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import { CollapsibleTable } from '../../components/CollapsibleTable';
import { MainContainer } from '../../components/MainContainerComp';
import ScrollIndicatorsComp from '../../components/ScrollIndicatorsComp/ScrollIndicatorsComp';
import { ITrainingHistoryData } from './TrainingHistoryData';
import { BCMEATrainingTypeCols, IndustryTrainingTypeCols, TrainingType, TrainingTypeTitle } from './TrainingHistoryModels';
import { Disclaimer } from './components/Disclaimer';
import { disclaimerContainerStyle, disclaimerContentStyle, disclaimerIconStyle, disclaimerStyle } from "./styled";

interface ITrainingHistoryProps {
  data: ITrainingHistoryData,
  onTabSelect: (tab: TrainingType) => void,
  selectedTab: TrainingType,
  showDisclaimer: boolean,
  onShowDisclaimer: () => void
}

export const TrainingHistory = ({
  data,
  onTabSelect,
  selectedTab,
  showDisclaimer,
  onShowDisclaimer
}: ITrainingHistoryProps) => {
  const bcmeaTrainingType = selectedTab === TrainingType.bcmea;
  const cols = bcmeaTrainingType ? BCMEATrainingTypeCols : IndustryTrainingTypeCols;

  const rows = data[selectedTab].map(item => ({
    description: item.description,
    period: bcmeaTrainingType ? item.period : item.site,
    type: bcmeaTrainingType ? item.type : item.status,
    status: bcmeaTrainingType ? item.status : item.expiry
  }))

  const selectTab = (e: React.SyntheticEvent, tab: number) => {
    e.stopPropagation();
    onTabSelect(tab === 0 ? TrainingType.bcmea : TrainingType.industry);
  }

  return (
    <MainContainer hasGreyBg>
      {showDisclaimer &&
        <Box sx={disclaimerContainerStyle}>
          <Box sx={disclaimerContentStyle}>
            <Disclaimer onClick={onShowDisclaimer} />
          </Box>
        </Box>
      }
      <Grid container>
        <Grid item xs={12} >
          <Box
            sx={disclaimerStyle}
            onClick={onShowDisclaimer}
          >
            <ErrorOutlineRoundedIcon sx={disclaimerIconStyle} />
            <Typography data-automation="status-code-desc-link">Status Code Descriptions</Typography>
          </Box>
        </Grid>
      </Grid>
      <Tabs
        aria-label="standard"
        value={bcmeaTrainingType ? 0 : 1}
        onChange={selectTab}
      >
        <Tab
          aria-label="standard"
          disableRipple
          label={TrainingTypeTitle.bcmea}
          data-automation="bcmea-training"
        />
        <Tab
          aria-label="standard"
          disableRipple
          label={TrainingTypeTitle.industry}
          data-automation="industry-training"
        />
      </Tabs>
      <Box sx={{ overflow: "auto", marginBottom: 2 }}>
        <Typography
          component={'div'}
          variant='container'
          data-automation="data-container"
        >
          <ScrollIndicatorsComp>
            <CollapsibleTable
              noDataMsg={bcmeaTrainingType ? 'No Training Records Available' : 'No Industry Training Records Available'}
              cols={cols.map(title => ({ title, align: 'left' }))}
              rows={rows}
              isOneLevel
            />
          </ScrollIndicatorsComp>
        </Typography>
      </Box>
    </MainContainer>
  )
}